import * as React from 'react';
import * as NotificationApi from '~/Api/Pigeon/NotificationEmailHtmlBody';
import { useApiResult } from '~/ApiHooks';
export var NotificationEmailDetail = function (_a) {
    var emailId = _a.emailId, notificationId = _a.notificationId;
    var requestResult = useApiResult(new NotificationApi.NotificationEmailHtmlBodyRequest(notificationId, emailId), [notificationId, emailId])[0];
    if (requestResult.isLoading || requestResult.value === null) {
        return <></>;
    }
    return <div dangerouslySetInnerHTML={{ __html: requestResult.value }}/>;
};
